export const I18N_NAMESPACE = 'core'

export const I18N_KEYS = Object.freeze({
  LOCATION_LABEL: 'analytics.timezone.locationLabel',
  LOCATION_TOOLTIP: 'analytics.timezone.locationTooltip',
  UTC_TOOLTIP: 'analytics.timezone.utcTooltip',
})

export const UTC_TIMEZONE = 'UTC'

export const SITE_ATTRIBUTES_TIMEZONE_DIMENSION = 'AnalyticsSiteAttributes.timezone'
export const SITE_ATTRIBUTES_SITE_ID_DIMENSION = 'AnalyticsSiteAttributes.siteId'
export const SITE_ATTRIBUTES_LOCATION_COUNT_MEASURE = 'AnalyticsSiteAttributes.locationCount'
export const FILTER_OPERATOR_EQUALS = 'equals'
